"use client";

export function BlogHeaderLayout({ baseFolder }: { baseFolder: string }) {
    return null;
    // e.g. "blog" or "cloudrightsizing-blog"
}
